import { useQueryClient } from '@tanstack/react-query';
import { pathgen } from 'object-path-generator';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { QueryKeys } from '../queryKeys';
import { useMutationState } from '../useMutationState';
export const useUpdateCustomPageTemplateTestIds = pathgen('useUpdateCustomPageTemplateTestIds');
export const useUpdateCustomPageTemplate = function useUpdateCustomPageTemplate() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutationState({
        mutationFn: (param)=>{
            let { businessId, templateId, data } = param;
            return api.customPageTemplates.update(businessId, templateId, data);
        },
        toasts: {
            successMessage: t.proposal.customPages.templates.updateSuccess(),
            successTestId: useUpdateCustomPageTemplateTestIds.SuccessToast(),
            errorTestId: useUpdateCustomPageTemplateTestIds.ErrorToast()
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.CustomPageTemplates
                ]
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        updateTemplate: mutate,
        isLoading
    };
};
